var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sankey-v2" },
    [
      _c("div", {
        ref: "chart",
        staticClass: "chart",
        class: { "is-loading": _vm.isLoading }
      }),
      _vm._v(" "),
      _vm.isLoading ? _c("loading-box") : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }